import { noop } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  branch,
  compose,
  withState,
  withProps,
  lifecycle,
  withHandlers,
  renderNothing,
  withPropsOnChange,
} from 'recompose';

import { getBarberByRoute } from '../barbers/selectors';
import { getIsPassedByIdOrRoute, getIsVisible } from './selectors';
import { hidePasscode, validatePasscode, setPasscodePassed, showPasscode } from './actions';

const hideIfNotVisibleForBarber = branch(
  ({ barber, visibleFor }) => !barber || (barber.route !== visibleFor && barber.id !== visibleFor),
  renderNothing,
);

const withBarberFromProps = compose(
  withProps(props => ({
    close: props.hidePasscode,
  })),
  withHandlers({
    onSubmit: props => (e) => {
      e.preventDefault();
      props.setPasscode(props.passcode);
      props.validatePasscode(props.barber.id, props.passcode).then((passcode) => {
        if (!passcode.valid && passcode.error) {
          props.setPasscodeError(passcode.error);
          return;
        }

        props.hidePasscode();
        props.setPasscodePassed(props.barber);
        props.router.push(props.link);
      });
    },
  }),
  hideIfNotVisibleForBarber,
);

const withBarberFromRoute = compose(
  connect(
    (state, ownProps) => {
      const barber = getBarberByRoute(state, ownProps.params.barberRoute);
      return {
        barber: barber ? barber.toJS() : null,
        isPassed: barber ? getIsPassedByIdOrRoute(state, barber.get('id')) : true,
      };
    }
  ),
  branch(
    props => !props.barber || props.isPassed,
    renderNothing,
  ),
  withPropsOnChange(
    ['barber'],
    (props) => {
      if (props.barber && props.barber.requirePasscode) {
        props.showPasscode(props.barber.id);
      }
    },
  ),
  withProps(() => ({
    close: noop,
  })),
  withHandlers({
    onSubmit: props => (e) => {
      e.preventDefault();
      props.setPasscode(props.passcode);
      props.validatePasscode(props.barber.id, props.passcode).then((passcode) => {
        if (!passcode.valid && passcode.error) {
          props.setPasscodeError(passcode.error);
          return;
        }

        props.hidePasscode();
        props.setPasscodePassed(props.barber);
      });
    },
  }),
  hideIfNotVisibleForBarber,
);

export default compose(
  connect(
    state => ({
      visibleFor: getIsVisible(state),
    }),
    {
      hidePasscode,
      showPasscode,
      validatePasscode,
      setPasscodePassed,
    }
  ),
  withRouter,
  withState('passcode', 'setPasscode', ''),
  withState('passcodeError', 'setPasscodeError', ''),
  withHandlers({
    onChange: props => e => props.setPasscode(e.target.value),
  }),
  withPropsOnChange(
    ['visibleFor'],
    (props) => {
      if (!props.visibleFor) {
        props.setPasscode('');
        props.setPasscodeError('');
      }
    }
  ),
  lifecycle({
    componentWillMount() {
      this.props.hidePasscode();
    },
  }),
  branch(
    props => props.barber,
    withBarberFromProps,
    withBarberFromRoute,
  ),
);



// WEBPACK FOOTER //
// ./src/app/passcode/PasscodeContainer.js